<template>
  <div class="ll-amount-card-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlAmountCardList",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-amount-card-list";
</style>